// api client
import { client } from '../api/client'

// types
import { StoreData, StoreUpdateData } from '../types/storeTypes'

const fetchData = (id: number): Promise<StoreData> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(`/OnBoarding/${id}/Store`)

      if (response.status === 200) {
        const storeData: StoreData = {
          essUserOnBoardingKey: response.data.essUserOnBoardingKey,
          hireDate: response.data.hireDate,
          pendingStartDate: response.data.pendingStartDate,
          storeName: response.data.storeName,
          brandingName: response.data.brandingName,
          storeShortName: response.data.storeShortName,
          storeAddress1: response.data.storeAddress1,
          storeAddress2: response.data.storeAddress2,
          storeAddress3: response.data.storeAddress3,
          storePhoneNumber: response.data.storePhoneNumber,
          storeNumber: response.data.storeNumber,
          department: response.data.department,
          employeeRole: response.data.employeeRole,
          perPayTypeDescription: response.data.perPayTypeDescription,
          perPayCycleDescription: response.data.perPayCycleDescription,
          perScheduleDescription: response.data.perScheduleDescription,
          rate: response.data.rate,
          perPayByDescription: response.data.perPayByDescription,
          storeStatusValue: response.data.storeStatusValue,
          statusDescription: response.data.statusDescription,
          storeAdress1: response.data.storeAdress1,
          storeAdress2: response.data.storeAdress2,
          storeCity: response.data.storeCity,
          storeState: response.data.storeState,
          storeZipCode: response.data.storeZipCode,
          scheduledHours: response.data.scheduledHours
        }

        resolve(storeData)
      } else {
        reject({ message: 'Could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const updateData = (id: number, data: StoreUpdateData): Promise<StoreData> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.patch(`/OnBoarding/${id}/Store`, data)

      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not fetch data' })
      }
      return null
    } catch (error) {
      reject(error)
    }
  })
}

export const storeService = {
  fetchData,
  updateData
}
